export default {
  data() {
    return {
      application_owner: {label:'Без фильтра', value: null},
      applicationOwnerOptions: [
        {
          label: 'Наше/Аренда',
          value: 'own',
        },
        {
          label: 'Клиента/Веб',
          value: 'client',
        },
        {
          label: 'Наше/Аренда и Клиента/Веб',
          value: 'own,client'
        },
        {
          label: 'Без фильтра',
          value: null,
        }
      ],
      /** It's index in array applicationOwnerOptions */
      application_owner_default_option_idx: 3,
      type: [],
      types: [
        {
          label: 'Белые',
          value: 'white'
        },
        {
          label: 'Серые',
          value: 'grey'
        },
        {
          label: 'Seo',
          value: 'seo'
        },
        {
          label: 'InfoBiz',
          value: 'infoBiz'
        }
      ],
    }
  },
  methods:{
    getAppOwnerByValue(value) {
      let appOwner =  this.applicationOwnerOptions.find((option)=> option.value === value)
      if(!appOwner.value){
        return  '';
      }

      return appOwner.label
    },

    getOfferTypeByValue(value) {
      let appType =  this.types.find((option)=> option.value === value)
      if(!appType.value){
        return  '';
      }

      return appType.label
    },

    getCurrentOfferTypes() {
      if(this.type.length === 0){
        return [];
      }

      return this.type.map((type) => type.value)
    },
  }
}



// WEBPACK FOOTER //
// ./resources/js/views/front/mixins/reportMixin.js